const renderIf = (condition, jsx) => (!condition ? null : jsx);

export { renderIf };
